export enum ProjectProfileModalMode {
  VIEW = "view",
  CREATE = "create",
  EDIT = "edit",
}
